import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enTranslations } from "./en";
import { esTranslations } from "./es";

i18n
  .use(initReactI18next)
  .init({
    lng: "es",
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      // English
      en: {
        translation: enTranslations
      },
      // Spanish
      es: {
        translation: esTranslations
      },
    },
  });

export default i18n;
